import {ActivityType, MemberAnswerFileType} from "../../../../typings/activity";
import React from "react";
import './feedback-task.scss'
import {Redirect} from "react-router-dom";
import dayjs from "dayjs";
import {RiDownload2Fill} from 'react-icons/ri'
import { Card } from "../../../../components/UI/Card";
import { Button } from '../../../../components/UI/Button'
import { Download } from 'lucide-react'
interface ITask {
	activity: ActivityType
}
const webUrl = process.env.REACT_APP_WEB_URL;
const FeedbackTask: React.FC<ITask> = ({ activity}) => {
	if(activity?.memberActivities){
		const { score, feedback, scored_date, member_answer, created_at } = activity?.memberActivities
		const memberAnswers: MemberAnswerFileType[] = JSON.parse(member_answer as any)
		return (
      <>
        <div className="w-full flex gap-2">
          <div className="w-1/2 flex flex-col gap-2">
            <div className="bg-white rounded-lg shadow border flex flex-col items-center w-full">
              <div className="p-2 border-b gradient-primary rounded-t-lg w-full text-white text-center">
                <span className={"text-xs font-bold"}>Diunggah Tanggal</span>
              </div>
              <div className="p-2">
                <div className="font-bold text-xs">
                  {dayjs(created_at).format("LLL")}
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow border flex flex-col items-center w-full">
              <div className="p-2 border-b gradient-primary rounded-t-lg w-full text-white text-center">
                <span className={"text-xs font-bold"}>Dinilai Tanggal</span>
              </div>
              <div className="p-2">
                <div className="font-bold text-xs">
                  {scored_date
                    ? dayjs(scored_date).format("LLL")
                    : "Menunggu Penilaian"}
                </div>
              </div>
            </div>
          </div>
          <Card
            className={`w-1/2 flex flex-col items-center justify-center gradient-accent p-6 cursor-pointer hover:scale-[1.02] transition-transform border-0 text-white`}
          >
            <span className={"fs-7 mb-2"}>Nilai Anda</span>
            <span className="text-6xl font-bold mb-2">{score ?? "-"}</span>
          </Card>
        </div>
        <div className="bg-white rounded-lg shadow border flex flex-col items-center w-full">
          <div className="px-4 py-3 border-b rounded-t-lg w-full bg-blue-500 text-white text-center">
            <span className={"card-title font-bold"}>Umpan Balik</span>
          </div>
          <div className="p-4">
            <div className="font-bold">{feedback ?? "-"}</div>
          </div>
        </div>
        {memberAnswers.map((f) => {
          return (
            <>
              <div className="bg-white rounded-lg shadow border flex flex-col items-center w-full">
                <div className="px-4 py-3 border-b rounded-t-lg w-full bg-primary text-white text-center">
                  <span className={"card-title font-bold"}>{f.file_name}</span>
                </div>
                <div className="p-4 w-full">
                  <div className="flex gap-2">
                    <div className="flex flex-col items-start gap-2 w-1/2 border-r border-gray-200">
                      <span className="text-sm">File Size: {f.file_size}</span>
                      <span className="text-sm">File Type: {f.file_ext}</span>
                    </div>
                    <div className="w-1/2 flex align-center justify-center">
                      <a
                        href={`${webUrl}static/task/${f.file_encrypt}`}
                        download={f.file_name}
                      >
                        <Download size={"3rem"} className="text-primary" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </>
    );
	}else{
		return <Redirect to={`/course/${activity?.course_id}`} />
	}

}
export default FeedbackTask
